// extracted by mini-css-extract-plugin
export default {"root":"base-wallet-card_root__fs-Z9","titleRow":"base-wallet-card_titleRow__Fwq7M","description":"base-wallet-card_description__jC6gR","tabs":"base-wallet-card_tabs__BtXjx"};